import { apiCall, ApiConfig } from '../../../config/api'
import {
  WorkOrderInBoundLocate,
  WorkOrderInboundSkuHistoryDetails,
  WorkOrderLocateLpn
} from '../../../interfaces/WorkOrder/WorkOrder'
import { usePutAway } from '../Context/usePutAway'
import { actionTypes } from '../types/actionTypes'
import { putAwayConst } from '../const/putAwayConst'
import { AxiosResponse } from 'axios'
import { StatusGenericInput } from '../types/reducerTypes'
import { FilterdItems, Item } from '../../../interfaces/Generic/State'
import { stepperTypes } from '../types/stepperTypes'
import { putAwayActions as actions } from './putAwayActions'
import { useUser } from '../../../hooks/useUser'
import { asnFinishedStates } from '../../../enums/eAsnState'
import { LpnState } from '../types/enums'

type SetInputType = 'setInputQty' | 'setUbication' | 'setSkuEan'
type SetInputName = 'inputQty' | 'ubication' | 'skuEan'

export const putAwayActions = () => {
  const { state, dispatch } = usePutAway()
  const {
    userDataState: { userData }
  } = useUser()
  const { options } = putAwayConst()
  const { setOriginsUnknown, setSuppliersUnknown, setTitlteDocsMatch } =
    actions()

  const setLastSearchedBy = (field: string): actionTypes => ({
    type: 'setLastSearchedBy',
    payload: field
  })

  const setSearch = (field: string): actionTypes => ({
    type: 'setSearch',
    payload: field
  })
  const setSearchValue = (value: string): actionTypes => ({
    type: 'setSearchValue',
    payload: value
  })

  const setWorkOrderLocate = (
    value: WorkOrderInBoundLocate[]
  ): actionTypes => ({
    type: 'setWorkOrderLocate',
    payload: value
  })

  const setItem = (value: WorkOrderInBoundLocate): actionTypes => ({
    type: 'setItem',
    payload: value
  })

  const setError = (
    value: string,
    status?: StatusGenericInput
  ): actionTypes => ({
    type: 'setError',
    payload: { error: value, status: status || 'default' }
  })

  const setStep = (value: number): actionTypes => ({
    type: 'setStep',
    payload: value
  })

  const setLoading = (value: boolean): actionTypes => ({
    type: 'setLoading',
    payload: value
  })

  const setResetState = (): actionTypes => ({
    type: 'setResetState'
  })
  const setInputValue = (
    value: string,
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type: type,
    payload: {
      ...state[name],
      value: value
    }
  })
  const setInputError = (
    error: string,
    status: StatusGenericInput,
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type: type,
    payload: {
      ...state[name],
      status,
      error
    }
  })

  const setResetPageState = (): actionTypes => ({
    type: 'setResetPageState'
  })

  const handleResetPage = () => {
    dispatch(setResetPageState())
    document.getElementById('ubication')?.focus()
  }

  const setResetInput = (type: SetInputType): actionTypes => ({
    type,
    payload: {
      value: '',
      status: 'default',
      error: ''
    }
  })

  const setDefaultStatusInput = (
    type: SetInputType,
    name: SetInputName
  ): actionTypes => ({
    type,
    payload: {
      ...state[name],
      status: 'default'
    }
  })

  const setViewField = (field: string): actionTypes => ({
    type: 'setViewField',
    payload: field
  })

  const setInputData = (
    value: string,
    error: string,
    status: StatusGenericInput,
    type: SetInputType
  ): actionTypes => ({
    type: type,
    payload: {
      value,
      error,
      status
    }
  })

  const clearUbication = () => {
    dispatch(setInputData('', '', 'success', 'setInputQty'))
  }

  const handleChangeGenericInput = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    type: SetInputType
  ) => {
    const name = e.target.name as SetInputName
    if (type === 'setInputQty') {
      if (parseInt(e.target.value) > 0) {
        dispatch(setInputData(e.target.value, '', 'success', 'setInputQty'))
      } else {
        dispatch(
          setInputData('', 'La cantidad no es válida', 'error', 'setInputQty')
        )
      }
      return
    }
    dispatch(setInputValue(e.target.value, type, name))
  }

  const handleResetGenericInput = (type: SetInputType) => {
    dispatch(setResetInput(type))
  }

  const mapperSearchOptions = () => {
    return options.find((x) => x.value === state.isSelected)?.name.toUpperCase()
  }

  const mapperDetailsOptions = (item: WorkOrderInBoundLocate) => {
    let option = ''
    let itemField = ''

    option = options.find((x) => x.value === state.isSelected)?.label!

    if (option === 'OT') {
      itemField = item.workOrderId.toString()
    } else {
      if (option === 'ASN') {
        itemField = item.asnNumber.toString()
      } else {
        itemField = item.lpn.toString()
      }
    }

    return `${option} ${itemField}`
  }

  const validateStep = (response: AxiosResponse) => {
    if (response.data.length > 1) {
      return dispatch(setStep(stepperTypes.stepLPNSelection))
    }

    if (response.data.length === 1) {
      if (asnFinishedStates.includes(response.data[0].asnStateId)) {
        dispatch(
          setError(
            `${mapperSearchOptions()} ${response.data[0].asnStateName}`,
            'success'
          )
        )
      } else {
        dispatch(setError('', 'default'))
        const workOrder: WorkOrderInBoundLocate = response.data[0]
        dispatch(setItem(workOrder))

        // este if faltaba controlar si no existe lpn o viene undefined
        if (
          workOrder.lpn.length > 1 ||
          (workOrder.lpn.length === 1 &&
            workOrder.lpn[0].lpnStateId === LpnState.Manage)
        ) {
          dispatch(setSearch('Lpn'))
          return dispatch(setStep(stepperTypes.stepLPNSelection))
        }

        return dispatch(setStep(stepperTypes.stepDescriptionPutAway))
      }
    }
  }

  const validateStepBack = (
    step: number,
    workOrderInboundLocate: WorkOrderInBoundLocate[]
  ) => {
    if (step === stepperTypes.stepDocsMatchPutAway) {
      dispatch(setStep(stepperTypes.stepSearchPutAway))
      dispatch(setResetState())
    }

    if (
      step === stepperTypes.stepDescriptionPutAway &&
      workOrderInboundLocate.length > 1
    ) {
      dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
    }

    if (
      step === stepperTypes.stepDescriptionPutAway &&
      workOrderInboundLocate.length === 1
    ) {
      dispatch(setStep(stepperTypes.stepSearchPutAway))
      dispatch(setResetState())
    }

    if (
      step === stepperTypes.stepLocateHistoryPutAway &&
      state.SkuListOnPosition.length === 0
    ) {
      dispatch(setStep(stepperTypes.stepDescriptionPutAway))
    }

    if (
      step === stepperTypes.stepLocateHistoryPutAway &&
      state.SkuListOnPosition.length > 0
    ) {
      dispatch(setIsShowNotification(true))
    }
  }

  const getWorkOrderLocate = () => {
    dispatch(setLoading(true))
    apiCall(
      'GET',
      `${ApiConfig.InboundApi}/GetWorkOrderLocate?${state.isSelected}=${state.searchValue}`
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderLocate([]))
          dispatch(setError('No fue posbile obtener los datos'))
        } else {
          dispatch(setWorkOrderLocate(response.data))
          validateStep(response)
          dispatch(setError(''))
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderLocate([]))
        dispatch(setError(message))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }
  const getWorkOrderLocateUnknown = (workOrderId: number) => {
    dispatch(setLoading(true))
    apiCall(
      'GET',
      `${ApiConfig.InboundApi}/GetWorkOrderLocate?WorkOrderId=${workOrderId}&UserId=${userData?.userId}`
    )
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderLocate([]))
          dispatch(setError('No fue posbile obtener los datos'))
        } else {
          dispatch(setLastSearchedBy(''))
          dispatch(setItem(response.data[0]))
          validateStep(response)
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderLocate([]))
        dispatch(setError(message))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const setUserId = (id: number): actionTypes => ({
    type: 'setUserId',
    payload: id
  })

  const handleSetUserId = (id: number) => dispatch(setUserId(id))

  const terminateLocateAsn = () => {
    dispatch(setLoading(true))
    const { item, positionId, SkuListOnPosition, userId } = state
    const asnLocatedSkusDto = SkuListOnPosition.map((sku) => ({
      skuId: sku.skuId,
      locatedQty: sku.value
    }))

    apiCall('POST', `${ApiConfig.InboundApi}/TerminateLocateASN`, {
      workOrderId: item?.workOrderId,
      asnId: item?.asnId,
      lpn: item?.lpn ? item.workingLpn : '',
      positionId: positionId,
      userId,
      asnLocatedSkusDto
    })
      .then((response: AxiosResponse) => {
        dispatch(setItem(response.data[0]))
        dispatch(setLoading(false))
        recalculateItems()
      })
      .catch((error) => alert(error))
    handleResetPage()
    dispatch(setCalculatedExcess(0))
  }

  const expandCollapseHeaderAndGrid = () => {
    const containerHeaderPutAway = document.getElementById(
      'containerHeaderPutAway'
    )!
    const containerGridPutAway = document.getElementById(
      'containerGridPutAway'
    )!
    const wrapper = document.querySelector('.wrapperHeader')!

    const containerDetails = document.getElementById('containerDetails')!

    if (
      containerHeaderPutAway.clientHeight === 140 ||
      containerHeaderPutAway.clientHeight === 170
    ) {
      containerHeaderPutAway.style.height = state.isExcess ? '260px' : '220px'

      if (containerGridPutAway !== null) {
        containerGridPutAway.style.height = state.isExcess ? '20px' : '40px'
      }
      containerDetails.style.height = '80px'
    } else {
      containerHeaderPutAway.style.height = wrapper.clientHeight + 'px'
      if (containerGridPutAway !== null) {
        containerGridPutAway.style.height = '100px'
      }
      containerDetails.style.height = '0px'
    }
  }

  const addElementToSKUList = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' && state.inputQty.status !== 'error') {
      // Buscar elemento existente considerando el batchId
      const existSKUOnList = state.SkuListOnPosition.find((item) => {
        const skuMatches = item.sku === state.skuEan.value
        if (state.selectedBatchId !== undefined) {
          return skuMatches && item.batchId === state.selectedBatchId
        }
        return (
          skuMatches && (item.batchId === undefined || item.batchId === null)
        )
      })

      const skuObject = getElegibleProducts(state.skuEan.value)[0]

      if (existSKUOnList) {
        const newElement = {
          ...existSKUOnList,
          value:
            parseInt(state.inputQty.value) +
            parseInt(existSKUOnList.value.toString())
        }
        dispatch(addItemList(newElement))
      } else {
        dispatch(
          addItemList({
            skuId: skuObject.skuId,
            productName: skuObject.skuName,
            sku: skuObject.sku,
            value: parseInt(state.inputQty.value),
            batchId: state.selectedBatchId
          })
        )
      }
      dispatch(setSkuLocated(skuObject.skuName))

      // Verificar si se completó un lote después de agregar el elemento
      const batchIdToCheck = state.selectedBatchId || existSKUOnList?.batchId

      if (batchIdToCheck) {
        // Calcular la nueva cantidad considerando lo que se acaba de agregar
        const newQtyForThisBatch = existSKUOnList
          ? parseInt(state.inputQty.value) +
            parseInt(existSKUOnList.value.toString())
          : parseInt(state.inputQty.value)

        if (
          checkBatchCompletionWithNewQty(
            batchIdToCheck,
            newQtyForThisBatch,
            existSKUOnList
          )
        ) {
          handleBatchCompletion(batchIdToCheck)
        }
      }

      // Setear input
      dispatch(setResetInput('setSkuEan'))
      dispatch(setResetInput('setInputQty'))
    }
  }

  const addItemList = (newItem: FilterdItems): actionTypes => ({
    type: 'setItemList',
    payload: [
      ...state.SkuListOnPosition.filter(
        (item) =>
          !(item.skuId === newItem.skuId && item.batchId === newItem.batchId)
      ),
      newItem
    ]
  })

  const validateRemoveItemList = (field: string, batchId?: number) => {
    dispatch(setSkuLocated(''))
    if (state.isSelectedFieldView === 'skuId') {
      return state.SkuListOnPosition.filter((i) => {
        if (batchId !== undefined) {
          return !(i.sku === field && i.batchId === batchId)
        }
        return !(
          i.sku === field &&
          (i.batchId === undefined || i.batchId === null)
        )
      })
    }

    return state.SkuListOnPosition.filter((i) => {
      if (batchId !== undefined) {
        return !(i.productName === field && i.batchId === batchId)
      }
      return !(
        i.productName === field &&
        (i.batchId === undefined || i.batchId === null)
      )
    })
  }

  const removeItemList = (field: string, batchId?: number): actionTypes => ({
    type: 'setItemList',
    payload: validateRemoveItemList(field, batchId)
  })

  const getElegibleProducts = (sku?: string) =>
    state.workOrderInboundLocate
      .flatMap((el) => el.workOrderDetails.map((el) => el))
      .filter((item) => (sku !== undefined ? item.sku === sku : true))

  const comparePositionWithSKU = (
    scannedPosition: string,
    scannedSKU: string
  ) => scannedPosition.toLowerCase() === scannedSKU.toLowerCase()

  const validateSKUInput = () => {
    const {
      skuEan: { value: scannedSKU },
      ubication: { value: scannedPosition }
    } = state

    const isSkuEqualToPosition = comparePositionWithSKU(
      scannedSKU,
      scannedPosition
    )

    if (isSkuEqualToPosition) {
      if (state.isExcess) {
        dispatch(setIsShowExcess(true))
      } else {
        terminateLocateAsn()
      }
      return
    }

    const elegibleSKUs = getElegibleProducts().map((el) => el.sku)

    if (elegibleSKUs.includes(state.skuEan.value)) {
      // hacer focus a la cantidad
      dispatch(setInputError('', 'success', 'setSkuEan', 'skuEan'))
      return
    }

    dispatch(setInputError('SKU no es válido', 'error', 'setSkuEan', 'skuEan'))
  }

  const setIsShowNotification = (isShowNotification: boolean): actionTypes => ({
    type: 'setIsShowNotification',
    payload: isShowNotification
  })

  const setIsShowExcess = (isShowExcess: boolean): actionTypes => ({
    type: 'setIsShowExcess',
    payload: isShowExcess
  })

  const setIsExcess = (isExcess: boolean): actionTypes => ({
    type: 'setIsExcess',
    payload: isExcess
  })

  const setResetLocate = (): actionTypes => ({
    type: 'setResetLocate'
  })

  const handleResetLocate = () => {
    dispatch(setResetLocate())
    document.getElementById('skuEan')?.focus()
  }

  const setCalculatedExcess = (calculatedExcess: number): actionTypes => ({
    type: 'setCalculatedExcess',
    payload: calculatedExcess
  })

  const setCalculatedInbound = (calculatedInbound: number): actionTypes => ({
    type: 'setCalculatedInbound',
    payload: calculatedInbound
  })

  const setSkuLocated = (skuLocated: string): actionTypes => ({
    type: 'setSkuLocated',
    payload: skuLocated
  })

  const setShowBatchCompletedModal = (show: boolean): actionTypes => ({
    type: 'setShowBatchCompletedModal',
    payload: show
  })

  const setCompletedBatchInfo = (
    batchId: number,
    batchInfo: string
  ): actionTypes => ({
    type: 'setCompletedBatchInfo',
    payload: { batchId, batchInfo }
  })

  const checkBatchCompletion = (batchId?: number): boolean => {
    if (!batchId || !state.item) {
      return false
    }

    // Obtener la información del lote desde workOrderDetails
    const batchDetails = state.item.workOrderDetails.filter(
      (detail) => detail.batchId === batchId
    )

    if (batchDetails.length === 0) {
      return false
    }

    // Calcular cantidad total requerida para este lote
    const totalRequiredQty = batchDetails.reduce(
      (total, detail) => total + (detail.realQty - detail.locatedQty),
      0
    )

    // Calcular cantidad actualmente ubicada para este lote
    const currentLocatedQty = state.SkuListOnPosition.filter(
      (item) => item.batchId === batchId
    ).reduce((total, item) => total + item.value, 0)

    // Verificar si se alcanzó o superó la cantidad requerida
    return currentLocatedQty >= totalRequiredQty
  }

  const checkBatchCompletionWithNewQty = (
    batchId: number,
    newQtyForThisBatch: number,
    existingElement?: any
  ): boolean => {
    if (!state.item) {
      return false
    }

    // Obtener la información del lote desde workOrderDetails
    const batchDetails = state.item.workOrderDetails.filter(
      (detail) => detail.batchId === batchId
    )

    if (batchDetails.length === 0) {
      return false
    }

    // Calcular cantidad total requerida para este lote
    const totalRequiredQty = batchDetails.reduce(
      (total, detail) => total + (detail.realQty - detail.locatedQty),
      0
    )

    // Calcular cantidad existente en otros elementos (excluyendo el elemento que se está actualizando)
    const existingQtyForOtherElements = state.SkuListOnPosition.filter(
      (item) => {
        if (item.batchId !== batchId) return false
        // Si hay un elemento existente siendo actualizado, excluirlo del cálculo
        if (
          existingElement &&
          item.skuId === existingElement.skuId &&
          item.batchId === existingElement.batchId
        ) {
          return false
        }
        return true
      }
    ).reduce((total, item) => total + item.value, 0)

    const totalQtyAfterAddition =
      existingQtyForOtherElements + newQtyForThisBatch

    // Verificar si se alcanzó o superó la cantidad requerida
    return totalQtyAfterAddition >= totalRequiredQty
  }

  const handleBatchCompletion = (batchId?: number) => {
    if (!batchId || !state.selectedBatchList.has(batchId)) return

    const batchInfo = state.selectedBatchList.get(batchId)
    const batchDisplayInfo = batchInfo?.batchNumber
      ? `Lote: ${batchInfo.batchNumber}`
      : `Lote ID: ${batchId}`

    dispatch(setCompletedBatchInfo(batchId, batchDisplayInfo))
    dispatch(setShowBatchCompletedModal(true))
  }

  const countItemUnits = () => {
    return state.SkuListOnPosition.reduce(
      (total, current) => total + current.value,
      0
    )
  }

  const recalculateItems = () => {
    const skuRealQty =
      state.SkuListOnPosition.length === 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.filter(
            (x) => x.skuName === state.skuLocated
          )[0].realQty!
        : state.SkuListOnPosition.length > 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.reduce(
            (total, current) => total + current.realQty,
            0
          )
        : state.item?.workOrderDetails
            .filter((x) =>
              x.skuName.includes(
                state.SkuListOnPosition.map((x) => x.productName).toString()
              )
            )
            .reduce((total, current) => total + current.realQty, 0)

    const skuLocatedQty =
      state.SkuListOnPosition.length === 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.filter(
            (x) => x.skuName === state.skuLocated
          )[0].locatedQty!
        : state.SkuListOnPosition.length > 1 && state.skuLocated.length > 0
        ? state.item?.workOrderDetails.reduce(
            (total, current) => total + current.locatedQty,
            0
          )
        : state.item?.workOrderDetails
            .filter((x) =>
              x.skuName.includes(
                state.SkuListOnPosition.map((x) => x.productName).toString()
              )
            )
            .reduce((total, current) => total + current.locatedQty, 0)

    const difference = countItemUnits() - skuRealQty! + (skuLocatedQty! || 0)

    if (difference >= 0) {
      dispatch(
        setCalculatedExcess(difference + state.item?.excessUnitsQty! || 0)
      )
      dispatch(
        setCalculatedInbound(
          countItemUnits() + state.item?.locatedUnitsQty! - difference
        )
      )
    } else {
      dispatch(setCalculatedExcess(state.item?.excessUnitsQty! || 0))
      dispatch(
        setCalculatedInbound(countItemUnits() + state.item?.locatedUnitsQty!)
      )
    }
  }

  const setWorkOrderSkuHistory = (
    workOrderSkuHistory: WorkOrderInboundSkuHistoryDetails[]
  ): actionTypes => ({
    type: 'setWorkOrderSkuHistory',
    payload: workOrderSkuHistory
  })

  const getWorkOrderSkuHistory = () => {
    dispatch(setLoading(true))
    apiCall('GET', `${ApiConfig.InboundHistoryApi}?WorkOrderId=3835&UserId=1`)
      .then((response: AxiosResponse) => {
        if (response.status !== 200) {
          dispatch(setWorkOrderSkuHistory([]))
          dispatch(setError('No fue posbile obtener los datos'))
        } else {
          dispatch(setWorkOrderSkuHistory(response.data.details))
          dispatch(setError(''))
        }
      })
      .catch(({ data: { message } }) => {
        dispatch(setWorkOrderSkuHistory([]))
        dispatch(setError(message))
      })
      .finally(() => {
        dispatch(setLoading(false))
      })
  }

  const handleSetStep = (value: number) => dispatch(setStep(value))

  const getPriority = async () => {
    apiCall(
      'GET',
      `${ApiConfig.InboundSearchApi}/Priority/${state.headerParamSearchValue}`
    )
      .then((response) => dispatch(setWorkOrderLocate(response.data)))
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }
  const getIboundSku = async () => {
    apiCall(
      'GET',
      `${ApiConfig.InboundSearchApi}/Sku/${state.skuUnknown.value}`
    )
      .then((response) => dispatch(setWorkOrderLocate(response.data)))
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }
  const getIboundSuppliers = async () => {
    apiCall('GET', `${ApiConfig.InboundSearchApi}/Suppliers`)
      .then((response) => {
        dispatch(setSuppliersUnknown(response.data))
      })
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }
  const getIboundOrigins = async () => {
    apiCall('GET', `${ApiConfig.InboundSearchApi}/Origins`)
      .then((response) => dispatch(setOriginsUnknown(response.data)))
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }

  const getUnknown = () => {
    switch (state.unknownFilter) {
      case 1:
        getPriority()
        break
      case 2:
        state.skuUnknown.status === 'success' && getIboundSku()
        break
      case 3:
        getIboundSuppliers()
        break
      case 4:
        getIboundOrigins()
        break

      default:
        break
    }
  }

  const getWorkOrdersSupplier = (supplierId: number, supplierName: string) => {
    apiCall('GET', `${ApiConfig.InboundSearchApi}/Supplier/${supplierId}`)
      .then((response) => {
        dispatch(setWorkOrderLocate(response.data))
        if (response.data.length === 1) {
          getWorkOrderLocateUnknown(response.data[0].workOrderId)
        } else {
          dispatch(setTitlteDocsMatch(supplierName))
          dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
        }
      })
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }
  const getWorkOrdersOrigin = (originId: number, originName: string) => {
    apiCall('GET', `${ApiConfig.InboundSearchApi}/Origin/${originId}`)
      .then((response) => {
        dispatch(setWorkOrderLocate(response.data))
        if (response.data.length === 1) {
          getWorkOrderLocateUnknown(response.data[0].workOrderId)
          return
        }
        dispatch(setTitlteDocsMatch(originName))
        dispatch(setStep(stepperTypes.stepDocsMatchPutAway))
      })
      .catch(({ data }) => {
        const errorMessage =
          data?.message === undefined
            ? 'Hubo un error al obtener datos'
            : data.message
        dispatch(setError(errorMessage, 'error'))
        setTimeout(() => {
          dispatch(setError('', 'error'))
        }, 2000)
      })
  }

  const getElementFromAsnDetails = (skuId: number, batchId?: number) => {
    const x = state.item?.workOrderDetails.filter((asnDetail) => {
      const lpnMatches = asnDetail.lpn === state.item?.workingLpn
      const skuMatches = asnDetail.skuId === skuId

      if (batchId !== undefined && batchId !== null) {
        // Si se proporciona batchId, buscar elementos con el mismo skuId y batchId
        return lpnMatches && skuMatches && asnDetail.batchId === batchId
      } else {
        // Si no se proporciona batchId, buscar elementos sin batchId
        return (
          lpnMatches &&
          skuMatches &&
          (asnDetail.batchId === undefined || asnDetail.batchId === null)
        )
      }
    })?.[0]
    return x
  }

  const getElementFromSkuListOnPosition = (skuId: number) => {
    return state.SkuListOnPosition?.filter(
      (element) => element.skuId === skuId
    )[0]
  }

  const getElementsWithExcess = () => {
    return state.SkuListOnPosition.filter(
      (skuObject) =>
        (getElementFromAsnDetails(skuObject.skuId, skuObject.batchId)
          ?.realQty || 0) -
          (getElementFromAsnDetails(skuObject.skuId, skuObject.batchId)
            ?.locatedQty || 0) <
        skuObject.value
    )
  }

  const generateItemList = (statusSku: boolean) => {
    const items: Item[] = state.SkuListOnPosition.map((skuObject) => {
      // Obtener la información del batch seleccionado
      const selectedBatch = skuObject.batchId
        ? state.selectedBatchList.get(skuObject.batchId)
        : undefined

      // Determinar si se debe mostrar información de lote basado en los valores del elemento específico
      const shouldShowBatchNumber =
        skuObject.batchId &&
        selectedBatch?.batchNumber !== null &&
        selectedBatch?.batchNumber !== undefined &&
        selectedBatch?.batchNumber !== ''

      const shouldShowExpirationDate =
        skuObject.batchId &&
        selectedBatch?.expirationDate !== null &&
        selectedBatch?.expirationDate !== undefined &&
        selectedBatch?.expirationDate !== ''

      const baseItem = {
        id: skuObject.skuId,
        name: statusSku ? skuObject.sku : skuObject.productName,
        value: skuObject.value,
        batchId: skuObject.batchId,
        batchNumber: shouldShowBatchNumber
          ? String(selectedBatch?.batchNumber)
          : undefined,
        batchExpirationDate: shouldShowExpirationDate
          ? String(selectedBatch?.expirationDate)
          : undefined,
        withExcess:
          (getElementFromAsnDetails(skuObject.skuId, skuObject.batchId)
            ?.realQty || 0) -
            (getElementFromAsnDetails(skuObject.skuId, skuObject.batchId)
              ?.locatedQty || 0) <
          skuObject.value
      }

      return baseItem
    })
    return items
  }

  const findWorkingLpn = () => {
    return state.item?.lpn.find(
      (x: WorkOrderLocateLpn) => x.lpn === state.item?.workingLpn
    )
  }

  return {
    setSearch,
    setSearchValue,
    getWorkOrderLocate,
    setWorkOrderLocate,
    mapperSearchOptions,
    setItem,
    setStep,
    validateStep,
    validateStepBack,
    setResetState,
    mapperDetailsOptions,
    handleChangeGenericInput,
    handleResetGenericInput,
    expandCollapseHeaderAndGrid,
    setInputError,
    setDefaultStatusInput,
    setViewField,
    addItemList,
    removeItemList,
    addElementToSKUList,
    validateSKUInput,
    terminateLocateAsn,
    setIsShowNotification,
    handleResetLocate,
    countItemUnits,
    recalculateItems,
    setIsExcess,
    handleResetPage,
    handleSetUserId,
    setIsShowExcess,
    getWorkOrderSkuHistory,
    handleSetStep,
    getUnknown,
    getWorkOrderLocateUnknown,
    getWorkOrdersSupplier,
    getWorkOrdersOrigin,
    getElementFromAsnDetails,
    getElementFromSkuListOnPosition,
    generateItemList,
    getElementsWithExcess,
    clearUbication,
    findWorkingLpn,
    setShowBatchCompletedModal,
    setCompletedBatchInfo,
    checkBatchCompletion,
    checkBatchCompletionWithNewQty,
    handleBatchCompletion
  }
}
